module.exports = {
  content: ['./pages/**/*.{js,ts,jsx,tsx}', './components/**/*.{js,ts,jsx,tsx}'],
  theme: {
    colors: {
      purple: [],
      green: [
        '#1de9b6',
        '#79b832',
        'rgb(129,178,20)',
        '#52c41a',
        '#7aaf39',
        'rgb(29, 202, 10)', // 5
        '#87d068',
      ],
      red: ['#E53935'],
      yellow: [],
      gray: [
        '#f2f2f2',
        'rgba(0, 0, 0, 0.1)',
        'rgba(0, 0, 0, 0.4)', // 2
        '#918dae',
        '#f0f0f0',
        '#dee2e6', // 5,
        'rgb(165, 166, 172)',
        'rgba(0,0,0,0.5)',
        '#6c757d', // 8
        'rgb(64 52 52)',
        '#696969', // 10 next default
        '#fafafa',
        '#888', // 12 hover
        '#1a1a1a',
        '#b4b4b4',
        'rgba(0,0,0,.06)', // 15 border
        '#eee',
        'rgba(0, 0, 0, 0.25)', // 17 disabled
        '#f5f5f5',
        '#d9d9d9',
        '#2b4660', // 20
        '#61788e',
      ],
      blue: [
        '#1890ff', // link
        '#0070f3',
        '#4285f4', // 2
        '#0077DB',
        '#00569E',
        '#C9E3F8', // 5
        '#211a58',
        '#f4f7f9', // 7
        '#2b286f;',
        '#3a4578',
        '#40a9ff', // 10
        'rgba(235, 244, 252,  0.75)',
        '#34268c', // 12
        '#162182', // 13 main
        '#b5e6f6',
      ],
      indigo20: '#E0E7FF',
      indigo30: '#C7D2FE',
      indigo40: '#A5B4FC',
      indigo50: '#818CF8',
      indigo60: '#4F46E5',
      indigo70: '#4F46E5',
      indigo80: '#4338CA',
      indigo90: '#3730A3',
      indigo100: '#2C2871',
      state10: '#F5F8FF',
      state30: '#E2E8F0',
      state40: '#CBD5E1',
      state60: '#64748B',
      red100: '#7F1D1D',
      amber10: '#FFFBEB',
      amber80: '#B45309',
      yellow20: '#FEF3C7',
      yellow50: '#FBBF24',
      light: '#94A3B8',
      warning: '#FBBF24',
      white50: 'rgba(255, 255, 255, 0.5)',

      black05: '#F8FAFC',
      black10: '#f1f5f9',
      black20: '#e2e8f0',
      black30: '#cbd5e1',
      black40: '#94a3b8',
      black50: '#64748b',
      black60: '#475569',
      black70: '#334155',
      black80: '#1e293b',
      black90: '#0f172a',

      berry05: '#F5F8FF',
      berry10: '#e0e7ff',
      berry20: '#c7d2fe',
      berry30: '#a5b4fc',
      berry40: '#818cf8',
      berry50: '#6366f1',
      berry60: '#4f46e5',
      berry70: '#4338ca',
      berry80: '#3730a3',
      berry90: '#312e81',
      berry100: '#2C2871',

      blue10: '#dbeafe',
      blue20: '#bfdbfe',
      blue30: '#93c5fd',
      blue40: '#60a5fa',
      blue50: '#3b82f6',
      blue60: '#2563eb',
      blue70: '#1d4ed8',
      blue80: '#1e40af',
      blue90: '#1e3a8a',

      green10: '#d1fae5',
      green20: '#a7f3d0',
      green30: '#6ee7b7',
      green40: '#34d399',
      green50: '#10b981',
      green60: '#059669',
      green70: '#047857',
      green80: '#065f46',
      green90: '#064e3b',

      sun10: '#fef3c7',
      sun20: '#fde68a',
      sun30: '#fcd34d',
      sun40: '#fbbf24',
      sun50: '#f59e0b',
      sun60: '#d97706',
      sun70: '#b45309',
      sun80: '#92400e',
      sun90: '#78350f',

      red10: '#fee2e2',
      red20: '#fecaca',
      red30: '#fca5a5',
      red40: '#f87171',
      red50: '#ef4444',
      red60: '#dc2626',
      red70: '#b91c1c',
      red80: '#991b1b',
      red90: '#7f1d1d',

      white: '#fff',
      black: '#000',
      white20: 'rgba(255, 255, 255, 0.2)',
      black500: 'rgba(255, 255, 255, 0.50)',
      transparent: 'transparent',
      other1: '#00D95F',
      other2: '#FB67CA',
      other3: '#107aca',
      other4: '#3fd5ce',
      other5: '#07b0a9',
      other6: '#049c96',
      other7: '#FF7A00',
    },
    backgroundImage: {
      search: "url('public/logo.webp)",
    },
    border: ['1px solid #6c757d !important', '1px solid #000'],
    fontFamily: {
      light: ['IRANSans_Light'], // 300
      regular: ['IRANSans_Regular'], // 400
      medium: ['IRANSans_Medium'], // 500
      semibold: ['IRANSans_SemiBold'], // 600
      bold: ['IRANSans_Bold'], // 700
    },
    extend: {
      flex: {
        2: '2 2 0%',
      },
      boxShadows: {
        card: '0px 20px 40px rgba(15, 24, 66, 0.1)',
        card2: '0px 3px 6px rgb(0 0 0 / 50%)',
        card3: '0px 2.075px 2.075px 0px rgba(137, 159, 209, 0.20)',
      },
    },
  },
  plugins: [],
};
